import { BrandContentMap } from './types';

export const brandContentEN: BrandContentMap = {
  dacia: {
    title: "Reliable Used Dacia Cars UK",
    description: "Discover reliable used Dacia cars from verified dealers. Logan, Duster and other models with complete history and professional verification.",
    h1: "Reliable Used Dacia Cars - Verified Dealers UK",
    intro: "Dacia remains one of the most popular car brands in Europe. Discover why used Dacia cars are the smart choice for safety and reliability.",
    badge: "🏆 Most Popular Budget Brand",
    models: [
      {
        name: "Dacia Logan",
        description: "Best-selling car with proven reliability over 20 years",
        features: ["Low maintenance", "Parts widely available", "Proven reliability"]
      },
      {
        name: "Dacia Duster", 
        description: "Affordable compact SUV with all-wheel drive",
        features: ["Versatile SUV", "Low fuel consumption", "Generous space"]
      },
      {
        name: "Dacia Sandero",
        description: "Compact and economical city car", 
        features: ["Perfect for city", "Economical", "Easy to park"]
      }
    ],
    whyChoose: [
      "Affordable spare parts widely available",
      "Authorized service centers nationwide", 
      "Complete vehicle history verified by experts",
      "Verified dealers with full transparency"
    ],
    tips: [
      "Check complete service history",
      "Inspect technical condition at authorized service",
      "Request all original documents",
      "Test all electronic systems"
    ],
    stats: [
      { value: "20+", label: "Years of reliability" },
      { value: "100%", label: "History verified" },
      { value: "500+", label: "Service centers" },
      { value: "24/7", label: "Dealer support" }
    ],
    faqs: [
      {
        question: "Is Dacia a good choice for used cars?",
        answer: "Yes! Dacia is ideal for used cars due to proven reliability, low maintenance costs and widespread parts availability."
      },
      {
        question: "What are the most popular Dacia models?",
        answer: "Logan (20-year leader), Duster (popular SUV), Sandero (perfect for city) and Spring (affordable electric)."
      },
      {
        question: "How do I check the history of a used Dacia?",
        answer: "Our verified dealers provide complete vehicle history, original documents and professional technical report for every Dacia."
      }
    ]
  },

  bmw: {
    title: "Used BMW for sale",
    description: "BMW listings from dealers and private sellers, with price, year, mileage and photos. Contact the seller directly.",
    h1: "BMW for sale",
    intro: "BMW represents excellence in German automotive engineering. Discover used BMW cars with top performance, technology and comfort.",
    badge: "BMW",
    models: [
      {
        name: "BMW 3 Series",
        description: "Premium sedan with perfect balance between performance and comfort",
        features: ["Advanced technology", "Sporty performance", "Premium comfort"]
      },
      {
        name: "BMW X3", 
        description: "Premium SUV with xDrive all-wheel drive",
        features: ["Versatile SUV", "xDrive standard", "Premium space"]
      },
      {
        name: "BMW X5",
        description: "Luxury SUV with cutting-edge technology", 
        features: ["Luxury and comfort", "Superior performance", "Innovative technology"]
      }
    ],
    whyChoose: ["Check the service history and documents before buying", "Ask the seller for the VIN for an independent check", "Have the car inspected at a garage of your choice", "The “Verified dealer” badge refers to the company, not the car"],
    tips: [
      "Check BMW digital history",
      "Inspect iDrive electronic systems",
      "Test xDrive on mixed routes",
      "Verify BMW software updates"
    ],
    stats: [],
    faqs: [
      {
        question: "Why choose a used BMW?",
        answer: "BMW offers premium technology, sporty performance and excellent value retention, making them ideal for used cars with preserved value."
      },
      {
        question: "What are the most popular BMW models?",
        answer: "3 Series (premium sedan), X3 (compact SUV), X5 (luxury SUV) and 5 Series (executive sedan) are the most sought after."
      },
      {
        question: "How do I check BMW technology on a used car?",
        answer: "Test iDrive and driver-assistance systems during the test drive, ask for the service history and ideally an independent inspection. RO Auto Market does not inspect vehicles."
      }
    ]
  }
};
